// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Form, FormGroup, Col, FormControl, Button, ControlLabel, Row, Alert, Checkbox, Modal } from 'react-bootstrap'
import config from '../config/config.json'
import { printableJsonError, fixScrollbar } from '../utils/enUtils.js'
import { MainSidebar } from '../components/mainsidebar'

export class Settings extends Component {
    constructor(props) {
        super(props)

        this.state = {
            formAlertType: 'danger',
            formAlertDisplay: 'none',
            formAlertText: '',
            showPassword: false,
            showDestroyWorkerModal1: false,
            showDestroyWorkerModal2: false,
        }

        this.init()

        this.handleOnSubmitProvider = this.handleOnSubmitProvider.bind(this)
        this.handleOnSubmitWorker = this.handleOnSubmitWorker.bind(this)
        this.formAlertUpdate = this.formAlertUpdate.bind(this)
        this.submitWorkerByApi = this.submitWorkerByApi.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleShowPassword = this.handleShowPassword.bind(this)
        this.prepareDestroyWorkerModal1 = this.prepareDestroyWorkerModal1.bind(this)
        this.prepareDestroyWorkerModal2 = this.prepareDestroyWorkerModal2.bind(this)
        this.openDestroyWorkerModal1 = this.openDestroyWorkerModal1.bind(this)
        this.openDestroyWorkerModal2 = this.openDestroyWorkerModal2.bind(this)
        this.closeDestroyWorkerModal1 = this.closeDestroyWorkerModal1.bind(this)
        this.closeDestroyWorkerModal2 = this.closeDestroyWorkerModal2.bind(this)
        this.confirmDestroyWorker = this.confirmDestroyWorker.bind(this)
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            this.props.router.push('/login?redirect=' + this.props.location.pathname)
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            if (storedData.profileType === 'worker') {
                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    average_strikes: storedData.average_strikes,
                    confirmed: storedData.confirmed,
                    email: storedData.email,
                    gender: storedData.gender,
                    purpose: storedData.purpose,
                    uid: storedData.uid,
                    first_name: storedData.first_name,
                    last_name: storedData.last_name,
                    last_active_at: storedData.last_active_at,
                    workers: JSON.parse(storedData.workers),
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleWorkerDataUpdateFromSessionStorage(data)
            }
            else {
                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    id: storedData.uid,
                    admin_first_name: storedData.fname,
                    admin_last_name: storedData.lname,
                    name: storedData.company,
                    address: storedData.address,
                    email: storedData.email,
                    license_count: storedData.licenseCount,
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleProviderDataUpdateFromSessionStorage(data)
            }
        }

        if (this.props.appData.authToken !== '') {
            this.data = this.props.appData
        }
        else {
            this.data = window.sessionStorage
        }
    }

    formAlertUpdate(type, display, text) {
        this.setState({
            formAlertType: type,
            formAlertDisplay: display,
            formAlertText: text
        })
    }

    clearFormAlert() {
        this.formAlertUpdate('success', 'none', '')
    }

    handleInputChange(e) {
        this.clearFormAlert()
    }

    handleShowPassword(e) {
        this.setState({
            showPassword: e.target.checked
        })
    }

    handleOnSubmitProvider(e) {
        e.preventDefault()

        let formData = {
            name: this.companyInput.value,
            address: this.addressInput.value,
            admin_first_name: this.fnameInput.value,
            admin_last_name: this.lnameInput.value,
            logo: "Placeholder.png"
        }

        // Only add password to data if was filled, otherwise don't update
        if (this.passwordInput.value || this.confPasswordInput.value) {
            if (this.passwordInput.value !== this.confPasswordInput.value) {
                alert("Passwords do not match")
                return
            } else {
                formData.password = this.passwordInput.value
            }
        }

        if (this.isValidInputProvider(formData)) {
            fetch(config[this.props.env] + config.api.provider_settings.endpoint + this.data.uid, {
                method: config.api.provider_settings.type,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.data.authToken
                },
                body: JSON.stringify({
                    provider: formData
                })
            }).then((response) => response.json())
                .then((responseJson) => {
                    if ('errors' in responseJson) {
                        let errorMessage = printableJsonError(responseJson.errors)
                        this.formAlertUpdate('danger', 'block', errorMessage)
                    }
                    else {
                        this.formAlertUpdate('success', 'block', 'Your settings have been updated!')
                        this.props.handleUpdateProviderSettings(formData)
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    isValidInputProvider(formData) {
        if (!formData.name) {
            alert("Please enter an organisation name")
        } else if (!formData.admin_first_name) {
            alert("Please enter your first name")
        } else if (!formData.admin_last_name) {
            alert("Please enter your last name")
        } else {
            return true;
        }

        return false;
    }

    handleOnSubmitWorker(e) {
        e.preventDefault()

        let formData = {
            first_name: this.fnameInput.value,
            last_name: this.lnameInput.value,
            gender: this.genderInput.value,
            purpose: this.purposeInput.value
        }

        // Only add password to data if was filled, otherwise don't update
        if (this.passwordInput.value || this.confPasswordInput.value) {
            if (this.passwordInput.value !== this.confPasswordInput.value) {
                alert("Passwords do not match")
                return
            } else {
                formData.password = this.passwordInput.value
            }
        }

        if (this.isValidInputWorker(formData)) {
            this.submitWorkerByApi(formData)
        }
    }

    isValidInputWorker(formData) {
        if (!formData.first_name) {
            alert("Please enter your first name")
        } else if (!formData.last_name) {
            alert("Please enter your last name")
        } else {
            return true;
        }

        return false;
    }

    submitWorkerByApi(formData) {
        fetch(config[this.props.env] + config.api.worker_settings.endpoint + this.data.uid, {
            method: config.api.worker_settings.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.data.authToken
            },
            body: JSON.stringify({
                worker: formData
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                if ('errors' in responseJson) {
                    let errorMessage = printableJsonError(responseJson.errors)
                    this.formAlertUpdate('danger', 'block', errorMessage)
                }
                else {
                    this.formAlertUpdate('success', 'block', 'Your settings have been updated!')
                    this.props.handleUpdateWorkerSettings(formData)
                }
            })
            .catch((error) => {
                console.error(error);
            })
    }

    prepareDestroyWorkerModal1() {
        return (
            <Modal show={this.state.showDestroyWorkerModal1} onHide={this.closeDestroyWorkerModal1}  >
                <Modal.Header>
                    <Modal.Title componentClass="h2">Delete My Account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4><b>Are you sure</b> you want to delete your account?</h4>
                    <h4>You will <b>lose access</b> to all your certificates and results. This process is <b>irreversable</b>.</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={6}>
                            <Button bsStyle="primary" onClick={this.openDestroyWorkerModal2}>Yes</Button>
                        </Col>
                        <Col sm={6}>
                            <Button bsStyle="primary" onClick={this.closeDestroyWorkerModal1}>No</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        )
    }

    openDestroyWorkerModal1() {
        this.setState({
            showDestroyWorkerModal1: true
        })
    }

    closeDestroyWorkerModal1() {
        this.setState({
            showDestroyWorkerModal1: false
        })

        fixScrollbar()
    }

    prepareDestroyWorkerModal2() {
        return (
            <Modal show={this.state.showDestroyWorkerModal2} onHide={this.closeDestroyWorkerModal2}  >
                <Modal.Header>
                    <Modal.Title componentClass="h2">Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4><b>Are you really sure</b> you want to delete your account?</h4>
                    <h4>This process is <b>irreversable</b>. You will <b>lose access</b> to all your certificates and results.</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={6}>
                            <Button bsStyle="primary" onClick={this.confirmDestroyWorker}>Confirm</Button>
                        </Col>
                        <Col sm={6}>
                            <Button bsStyle="primary" onClick={this.closeDestroyWorkerModal2}>Cancel</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        )
    }

    openDestroyWorkerModal2() {
        this.setState({
            showDestroyWorkerModal1: false,
            showDestroyWorkerModal2: true
        })
    }

    closeDestroyWorkerModal2() {
        this.setState({
            showDestroyWorkerModal2: false
        })

        fixScrollbar()
    }

    confirmDestroyWorker() {
        this.destroyWorkerApi(this.props.env, config)

        fixScrollbar()
    }

    destroyWorkerApi(env, config) {
        fetch(config[env] + config.api.worker_destroy.endpoint + this.data.uid, {
            method: config.api.worker_destroy.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                if ('errors' in responseJson) {
                    let errorMessage = printableJsonError(responseJson.errors)
                    this.formAlertUpdate('danger', 'block', errorMessage)
                } else {
                    console.log("Account destroyed. " + JSON.stringify(responseJson))

                    // Force logout
                    window.sessionStorage.clear()
                    this.props.handleLoginStateChange(false, "login")
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    render() {
        if (this.data.profileType === 'provider') {
            return (
                <div className="provider-settings-container settings-container page-container">
                    <MainSidebar
                        profileType={this.props.appData.profileType}
                        logout={this.props.handleLoginStateChange}
                        profile={3}
                        appData={this.data}
                    />

                    <div className="main-body" style={{ marginLeft: "100px" }}>
                        <Row>
                            <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                                <div className="main-header">
                                    <h2 className="title">Settings</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                                <Alert bsStyle={this.state.formAlertType} style={{ display: this.state.formAlertDisplay }} onDismiss={this.handleAlertDismiss}>
                                    <h3>{this.state.formAlertType === 'danger' ? "Something went wrong!" : "Success"}</h3>
                                    <p className="alert-text">{this.state.formAlertText}</p>
                                </Alert>
                            </Col>
                        </Row>
                        <Form horizontal className="settings-form">
                            <FormGroup controlId="formHorizontalCompany">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Company
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" placeholder="Company" inputRef={ref => { this.companyInput = ref }} defaultValue={this.data.company} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalAdminFName">
                                <Col componentClass={ControlLabel} sm={4}>
                                    First Name
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" placeholder="First Name" inputRef={ref => { this.fnameInput = ref }} defaultValue={this.data.fname} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalAdminLName">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Last Name
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" placeholder="Last Name" inputRef={ref => { this.lnameInput = ref }} defaultValue={this.data.lname} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalCompanyEmail">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Email
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" placeholder="Email" autoComplete="off" value={this.data.email} disabled />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalPassword">
                                <Col componentClass={ControlLabel} sm={4}>
                                    New Password
                                </Col>
                                <Col sm={5}>
                                    <FormControl type={this.state.showPassword ? "text" : "password"} placeholder="Password" autoComplete="new-password" inputRef={ref => { this.passwordInput = ref }} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalConfirmPassword">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Confirm New Password
                                </Col>
                                <Col sm={5}>
                                    <FormControl type={this.state.showPassword ? "text" : "password"} placeholder="Confirm Password" autoComplete="new-password" inputRef={ref => { this.confPasswordInput = ref }} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalCompanyAddress">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Address
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" placeholder="Address" inputRef={ref => { this.addressInput = ref }} defaultValue={this.data.address} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalShowPassword">
                                <Col smOffset={4} sm={5}>
                                    <Checkbox onChange={this.handleShowPassword} >
                                        Show Password
                                    </Checkbox>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col smOffset={4} sm={3}>
                                    <span className="delete-account">
                                        <a href={"mailto:enquiries@enablerinteractive.com?Subject=Request to Delete Organisation Account " + this.props.appData.uid} target="_top">Request Account Deletion
                                        </a>
                                    </span>
                                </Col>
                            </FormGroup>

                            <hr className="invisible post-form" />

                            <FormGroup>
                                <Col smOffset={4} sm={5}>
                                    <Button type="submit" bsStyle="primary" onClick={this.handleOnSubmitProvider}>
                                        Update
                                    </Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </div>
                </div>
            )
        }
        else {
            let worker = this.props.appData.authToken === '' ? window.sessionStorage : this.data.workers[0]

            return (
                <div className="settings-container page-container">
                    <MainSidebar
                        profileType={this.props.appData.profileType}
                        logout={this.props.handleLoginStateChange}
                        profile={3}
                        appData={this.data}
                    />

                    <div className="main-body" style={{ marginLeft: "100px" }}>
                        <Row>
                            <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                                <div className="main-header">
                                    <h2 className="title">Settings</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                                <Alert bsStyle={this.state.formAlertType} style={{ display: this.state.formAlertDisplay }} onDismiss={this.handleAlertDismiss}>
                                    <h3>{this.state.formAlertType === 'danger' ? "Something went wrong!" : "Success"}</h3>
                                    <p className="alert-text">{this.state.formAlertText}</p>
                                </Alert>
                            </Col>
                        </Row>
                        <Form horizontal className="settings-form">
                            <FormGroup controlId="formHorizontalFName">
                                <Col componentClass={ControlLabel} sm={4}>
                                    First Name
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" placeholder="First Name" inputRef={ref => { this.fnameInput = ref }} defaultValue={worker.first_name} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalLName">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Last Name
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" placeholder="Last Name" inputRef={ref => { this.lnameInput = ref }} defaultValue={worker.last_name} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Email
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" placeholder="Email" autoComplete="off" value={worker.email} disabled />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalPassword">
                                <Col componentClass={ControlLabel} sm={4}>
                                    New Password
                                </Col>
                                <Col sm={5}>
                                    <FormControl type={this.state.showPassword ? "text" : "password"} placeholder="Password" autoComplete="new-password" inputRef={ref => { this.passwordInput = ref }} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalConfirmPassword">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Confirm New Password
                                </Col>
                                <Col sm={5}>
                                    <FormControl type={this.state.showPassword ? "text" : "password"} placeholder="Confirm Password" autoComplete="new-password" inputRef={ref => { this.confPasswordInput = ref }} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalGender">
                                <Col componentClass={ControlLabel} sm={4}>
                                    You Identify As
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" placeholder="Gender" defaultValue={worker.gender} inputRef={ref => { this.genderInput = ref }} onChange={this.handleInputChange} />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalPurpose">
                                <Col componentClass={ControlLabel} sm={4}>
                                    I am
                                </Col>
                                <Col sm={5}>
                                    <FormControl type="text" componentClass="textarea" defaultValue={worker.purpose} inputRef={ref => { this.purposeInput = ref }} onChange={this.handleInputChange}
                                        placeholder="We would appreciate you completing the sentence beginning with 'I am', to understand how Enabler is meeting your needs or otherwise." />
                                    <FormControl.Feedback />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalShowPassword">
                                <Col smOffset={4} sm={5}>
                                    <Checkbox onChange={this.handleShowPassword} >
                                        Show Password
                                    </Checkbox>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col smOffset={4} sm={3}>
                                    <Button type="button" bsStyle="danger" onClick={this.openDestroyWorkerModal1}>
                                        Delete My Account
                                    </Button>
                                </Col>
                            </FormGroup>

                            <hr className="invisible post-form" />

                            <FormGroup>
                                <Col smOffset={4} sm={6}>
                                    <Button type="submit" bsStyle="primary" onClick={this.handleOnSubmitWorker}>
                                        Update
                                    </Button>
                                </Col>
                            </FormGroup>
                        </Form>

                        {this.prepareDestroyWorkerModal1()}
                        {this.prepareDestroyWorkerModal2()}
                    </div>
                </div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/settings.js